export function isHapisumuDomain(domain) {
  if (/localhost.*/.test(domain)) return true
  return /.*\.?hapisumu.jp/.test(domain)
}

function getUrlWithDomain(url) {
  const pathOnly = url.startsWith('/');
  let dummyBase = pathOnly ? 'http://hapisumu.jp/' : undefined // パスのみの時にはURLはインスタンス化できないので仮のドメインを設定する
  try {
    return new URL(url, dummyBase)
  } catch (e) {
    // 不正なURL
    return null
  }
}

// LPの種別を返す。対象外・空・不正なURLなら null。
export function lpTypeOf(url) {
  if (!url || url.length === 0) return null

  const uri = getUrlWithDomain(url)
  if (uri === null) return null

  if (uri.hostname.length !== 0 && !isHapisumuDomain(uri.hostname)) {
    return null
  }

  if (uri.pathname.startsWith('/lp/reform_')) return 'reform'
  if (uri.pathname.startsWith('/lp/rebuild_')) return 'rebuild'
  if (uri.pathname.startsWith('/loan')) return 'loan'
  return null
}

// 今いるURLから記事名を取得 /reform-123/ -> reform123, /article/estimate/123/ -> rebuild/article/estimate/123
export function getPostSlug() {
  if (window.location.pathname === '/') return 'home'

  const slug = window.location.pathname.split('/').filter(function (path) {
    return path !== ''
  }).join('/')

  if (window.location.hostname.startsWith('rebuild')) return `rebuild/${slug}`

  return slug
}
